exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-2951e63b]::-webkit-inner-spin-button,input[data-v-2951e63b]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-2951e63b]{-moz-appearance:textfield}.tanpawrap[data-v-2951e63b]{white-space:nowrap}", ""]);

// exports
